module.exports = __webpack_public_path__ + "static/media/GetToken.1c30e19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/GetToken.png
// module id = 944
// module chunks = 0